export async function brands() {
  const b = await fetch('/api/v1/brands')
  const c = await b.json()
  return c
}
